<template>
  <NotificationToast
    v-for="(notification, index) of notifications"
    :key="index"
    :notification="notification.value"
    :open="notification.value.open"
    :duration="getDuration(notification.value)"
    @update:open="(value) => (notification.value.open = value)"
  />
  <ToastViewport
    class="fixed right-4 bottom-28 left-4 z-50 flex flex-col gap-4 sm:left-auto"
  />
</template>

<script setup lang="ts">
import { ToastViewport } from 'reka-ui';
import NotificationToast from '../components/NotificationToast.vue';
import { useNotifications, type Notification } from '../stores/notificationStore';

const { notifications } = useNotifications();

const getDuration = ({ timeout, progress }: Notification, defaultDuration = 5000) => {
  if (typeof progress === 'number' || timeout === null) {
    return Infinity;
  }
  return timeout ?? defaultDuration;
};
</script>
